const wizardScreens = {
  intro: {
    headline: 'Welcome to Bambee',
    copy: "Let's get your account set up so you can start working with your dedicated HR Manager.",
  },
  'meet-your-manager': {
    headline: 'Meet Your HR Manager',
    copy: 'Your dedicated HR Manager is here to help you navigate all your HR needs.',
  },
  'schedule-a-call': {
    headline: 'Schedule Your Welcome Call',
    copy: 'Schedule a call with your HR Manager to discuss your business needs and get started.',
  },
  'about-your-company': {
    headline: 'Tell Us About Your Company',
    copy: 'Help us understand your business so we can tailor our HR services to your needs.',
  },
  'company-audit': {
    headline: 'About Your Company',
    copy: 'Answer a few questions about your company so we can customize your HR experience.',
  },
  'add-employees': {
    headline: 'Your Employees Are Ready to Be Added',
    copy: "Add your workers so they can access Bambee's HR resources. We won't contact them until you're ready.",
  },
  'no-staff': {
    headline: 'How Many Workers Do You Have?',
    subheadline:
      'Tell us about your workforce so we can set up your account correctly.',
  },
  confirmation: {
    headline: "You're All Set!",
    copy: 'Great job completing your onboarding! Your dedicated HR Manager is ready to help you tackle your HR needs.',
  },
  'confirmation-no-staff': {
    headline: 'Almost There!',
    copy: "You've completed the initial setup. Remember to add your workers when you're ready to get the most out of Bambee.",
  },
};

const fetchContent = async () => {
  return wizardScreens;
};

export default fetchContent;
